import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import PageHeader from 'layout/pageHeader';
import { useTranslation } from 'helpers/languages/translations';
import ColorManagementTab from 'pages/Preferences/components/molecules/ColorsTab';
import { useTabNavigate } from 'router/tabsMapper';
import { useGetAuthorizedTabsSelector } from 'core/redux/selectors/authSelectors';

const PATH = 'preferences';
const ID = 'cdm_preferences';
const NAME = 'page.preferences';

const ColorManagement = () => {
    const { authorizedTabs } = useGetAuthorizedTabsSelector();
    const displayColorsTab = authorizedTabs.includes('cdm_colors');
    const { tabIndex, setTabIndex } = useTabNavigate('preferences', { colors: displayColorsTab });

    const translate = useTranslation();

    const renderTabs = () => (
        <Tabs size="sm" onChange={(index) => setTabIndex(index)} index={tabIndex} isLazy>
            <TabList>{displayColorsTab && <Tab _focus={{ boxshadow: 'none' }}>{translate('tab.colors')}</Tab>}</TabList>
            <TabPanels>
                {displayColorsTab && (
                    <TabPanel px="0">
                        <ColorManagementTab />
                    </TabPanel>
                )}
            </TabPanels>
        </Tabs>
    );

    return (
        <Box>
            <PageHeader icon={{ name: 'preferences' }} pageTitle={translate(NAME) as string}></PageHeader>
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { ID, PATH, NAME };
export default ColorManagement;
